/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from 'axios'
import {FC, useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'
// import {useParams} from 'react-router-dom'
import {AnimaBaixo} from '../../../../../../../_metronic/assets/animation/styles'
import {ChartsWidget1} from '../../../../../../../_metronic/partials/widgets'
import {CardSystemWidgetSGT} from '../../../../../../../_metronic/partials/widgets/cardSystem/CardSystemWidgetSGT'
import {CardSystemWidgetSGT2} from '../../../../../../../_metronic/partials/widgets/cardSystem/CardSystemWidgetSGT2'
import {CardLoading} from '../../../../../../../_metronic/partials/widgets/loading/CardLoading'
import {PointAdd} from '../../../../../../../_metronic/partials/widgets/map/pointAdd'
import {LastPaymentsListOneProperty} from '../../../components/lastPayments-list/LastPaymentsListOneProperty'
import {Properties} from '../../../components/property-list/core/_models'

interface props {
  data?: Properties
}
const API_URL = process.env.REACT_APP_API_URL || 'api'

const DashboardOneProperties: FC<props> = ({data}) => {
  const [latitude, setLatitude] = useState(0)
  const [longitude, setLongitude] = useState(0)
  const [linkedLicenses, setLinkedLicenses] = useState([])

  const {uuid} = useParams()

  useEffect(() => {
    let X = Math.floor(Math.random() * 10)

    if (X <= 2) {
      //Lago Coração
      setLatitude(41.3039167)
      setLongitude(-81.9016944)
    } else if (X <= 4) {
      //lago Azul
      setLatitude(38.4833889)
      setLongitude(-109.6813333)
    } else if (X <= 6) {
      //formas
      setLatitude(35.45328522)
      setLongitude(-120.499879)
    } else if (X <= 8) {
      //violao
      setLatitude(-33.867676)
      setLongitude(-63.986411)
    } else {
      //ambipar
      setLatitude(-20.31573)
      setLongitude(-40.29003)
    }
  }, [])

  useEffect(() => {
    if (uuid) {
      getLinkedLicenses(uuid)
    }
  }, [uuid])

  async function getLinkedLicenses(uuid: string) {
    const {data} = await axios.get(`${API_URL}/sgt/v1/properties/${uuid}/linked_licenses`)
    const linkedLicenses = data.data
    setLinkedLicenses(linkedLicenses)
  }
  return (
    <>
      {data?.uuid ? (
        <AnimaBaixo>
          <div className='row '>
            {/* inicio primeiro card */}
            <div className='col-lg-6 col-sm-6'>
              {/* condicional de loading para o card */}
              <CardSystemWidgetSGT
                key='CardSystemWidgetSGT'
                className=''
                name={data?.name || ''}
                city={data.address?.city || ''}
                UF={data.address?.state || ''}
                fields={data.fields || ''}
                regularized={data.regularized || undefined}
                enterprises={data.enterprises || ''}
                linkedLicenses={linkedLicenses || undefined}
                contract={''}
              />
            </div>
            {/* fim primeiro card */}
            {/* inicio segundo card */}
            <div className='col-lg-6 col-sm-6 '>
              {/* condicional de loading para o card */}
              <CardSystemWidgetSGT2
                className=''
                issue_cost='2.732.191,80'
                maintenance_cost='2.732.191,80'
                renovation_cost='2.732.191,80'
              />
            </div>
            {/* fim segundo card */}

            {/* inicio terceiro card */}
            <div className='row'>
              <div className='col-xxl-6 col-lg-8 col-sm-6 mt-5'>
                <ChartsWidget1 className='' />
                <LastPaymentsListOneProperty />
              </div>

              {/* inicio quinto card */}
              <div className='col-xxl-6 col-lg-4 col-sm-6 mt-5 mb-1 rounded'>
                {/* condicional de loading para o card */}
                <PointAdd
                  name={data?.id || ''}
                  description={data?.code || ''}
                  latitude={latitude}
                  longitude={longitude}
                  zoom={18}
                  duration={1500}
                />
              </div>
            </div>
            {/* fim terceiro card */}
          </div>
        </AnimaBaixo>
      ) : (
        <CardLoading width='30%' height='30%' />
      )}
    </>
  )
}
export {DashboardOneProperties}
